import React, { useState, useContext } from "react";
// Context
import { BrandsContext } from "../data/brands/BrandsContext";
import { useData } from "../data/general/DataContext";
// Components
import TablePage from "../core/TablePage";
import BrandsAddModal from "../modals/brands/BrandsAddModal";
import BrandsUpdateModal from "../modals/brands/BrandsUpdateModal";
// UI
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { FaTrash, FaPencilAlt } from "react-icons/fa";


function BrandsPage() {
    const { brandsList, addBrand, updateBrand, deleteBrand, statusdata } = useContext(BrandsContext);

    const [selectedBrand, setSelectedBrand] = useState(null);
    const [showAddModal, setShowAddModal] = useState(false);
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedStatus, setSelectedStatus] = useState([]);
    const { windowMode } = useData();

    // Action Menu
    const ActionMenu = ({ rowData }) => {
        const op = React.useRef(null);
         if (windowMode === "mobile") return null;

        return (
            <>
                <Button
                    label="..."
                    className="p-button-rounded p-button-text"
                    style={{ minWidth: "40px", fontSize: "22px", fontWeight: "bold" }}
                    onClick={(e) => op.current.toggle(e)}
                />
                <OverlayPanel ref={op} dismissable showCloseIcon={false} style={{ padding: "0.5rem", left: "-5px" }}>
                    <div className="flex flex-col gap-0 p-2 w-32">
                        <Button
                            icon={<FaPencilAlt />}
                            label="Düzenle"
                            className="p-button-text w-full justify-start"
                            style={{ fontSize: "14px", gap: "10px" }}
                            onClick={() => {
                                setSelectedBrand(rowData);
                                setShowUpdateModal(true);
                                op.current.hide();
                            }}
                        />
                        <div className="w-full border-t border-gray-300 my-1"></div>
                        <Button
                            icon={<FaTrash />}
                            label="Sil"
                            className="p-button-text w-full justify-start"
                            style={{ color: "red", fontSize: "14px", gap: "10px" }}
                            onClick={() => {
                                deleteBrand(rowData.id);
                                op.current.hide();
                            }}
                        />
                    </div>
                </OverlayPanel>
            </>
        );
    };

    // Table Columns
    const columns = [
        { field: "id", header: "ID", hideInFilter: true },
        { field: "name", header: "Marka Adı" },
        { field: "description", header: "Açıklama" },
        { field: "status", header: "Durum" },
 {
              header: "İşlemler",
              body: (rowData) =>
                windowMode === "mobile" ? (
                  // Mobil görünümde direkt butonlar
                  <div className="flex gap-2 mt-2 w-full">
                    <Button
                      icon={<FaPencilAlt />}
                      label="Düzenle"
                      className="flex-1"
                      style={{
                        backgroundColor: "#3b82f6",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        height: "26px",
                        fontSize: "10px",
                        justifyContent: "center",
                        gap: "4px",
                        padding: "0 6px",
                      }}
                      onClick={() => {
                        setSelectedBrand(rowData);
                        setShowUpdateModal(true);
                      }}
                    />
                    <Button
                      icon={<FaTrash />}
                      label="Sil"
                      className="flex-1"
                      style={{
                        backgroundColor: "#ef4444",
                        color: "white",
                        border: "none",
                        borderRadius: "6px",
                        height: "26px",
                        fontSize: "10px",
                        justifyContent: "center",
                        gap: "4px",
                        padding: "0 6px",
                      }}
                      onClick={() => deleteBrand(rowData.id)}
                    />
                  </div>
                ) : (
                  <ActionMenu rowData={rowData} />
                ),
              hideInFilter: true,
            },
    ];

    const enhancedColumns = columns.map((col) =>
        col.field === "id" ? { ...col, style: { width: "60px", padding: "0 12px" } } : { ...col, style: { padding: "0 12px" } }
    );

    // Filtreleme
    const filteredBrands = brandsList.filter(
        (b) =>
            (!selectedStatus.length || selectedStatus.includes(b.status)) &&
            (!searchTerm || b.name.toLowerCase().includes(searchTerm.toLowerCase()))
    );

    const columnFilterOptions = {
        status: { type: "checkbox", options: statusdata, value: selectedStatus, onChange: setSelectedStatus },
        name: { type: "text" },
        description: { type: "text" },
    };

    return (
        <>
            <div className="p-6">
                <TablePage
                    title="Marka Listesi"
                    subTitle="Marka ekleyebilir, düzenleyebilir veya silebilirsiniz."
                    columns={enhancedColumns}
                    data={filteredBrands}
                    defaultRows={10}
                    rowsPerPageOptions={[10, 15, 25, 50,100]}
                    showSearch
                    searchValue={searchTerm}
                    onSearchChange={(e) => setSearchTerm(e.target.value)}
                    onAdd={() => setShowAddModal(true)}
                    columnFilterOptions={columnFilterOptions}
                />
            </div>

            <BrandsAddModal
                isOpen={showAddModal}
                onClose={() => setShowAddModal(false)}
            />

            <BrandsUpdateModal
                isOpen={showUpdateModal}
                onClose={() => setShowUpdateModal(false)}
                brandId={selectedBrand ? selectedBrand.id : null}
            />
        </>
    );
}

export default BrandsPage;
